import { Toggle } from '@ets/design-system';

import { useDispatch, useSelector } from '_common/hooks';
import {
  selectTemplateById,
  useInstallTemplateMutation,
} from 'Settings/pages/TenantSettingsPage/Templates/TemplatesApi';
import { openAndUpdateModal } from '_common/modals/ModalsSlice';

import styles from './ActionsCell.module.scss';

type ActionsCellProps = {
  templateId: string;
};

const ActionsCell = ({ templateId }: ActionsCellProps) => {
  const dispatch = useDispatch();

  const template = useSelector((state) => selectTemplateById(state, templateId));
  const [installTemplate] = useInstallTemplateMutation();

  if (!template) {
    return null;
  }

  const handleUninstallClick = () => {
    dispatch(
      openAndUpdateModal({
        modal: 'ConfirmationModal',
        data: {
          title: 'TEMPLATE_UNINSTALL_HEADER',
          titleValues: { title: template.name },
          message: 'TEMPLATE_UNINSTALL_MESSAGE',
          messageValues: { title: template.name },
          confirmButtonTextId: 'UNINSTALL',
          confirmButtonTextValues: {},
          confirmButtonType: 'primary',
          cancelButtonTextId: 'global.cancel',
          actionCode: 'uninstallTemplate',
          actionValue: { id: templateId, name: template.name },
          cancelButtonShow: true,
        },
      }),
    );
  };
  const handleInstallClick = () => {
    installTemplate({ id: templateId, name: template.name });
  };

  const getButtonProps = () => {
    switch (template.status) {
      case 'installed':
      case 'outdated':
        return (
          <Toggle
            variant="link"
            size="s"
            isToggled={false}
            iconProps={{ icon: 'check', color: 'success' }}
            onClick={handleUninstallClick}
            testId="uninstall"
          />
        );
      case 'not_installed':
        return (
          <Toggle
            variant="link"
            size="s"
            isToggled={false}
            iconProps={{ icon: 'circle-plus', color: 'primary' }}
            onClick={handleInstallClick}
            testId="install"
          />
        );
      default:
        throw Error(`Unknown Extension state ${template.status}`);
    }
  };

  return <div className={styles.root}>{getButtonProps()}</div>;
};

export default ActionsCell;
